(() => {
 function initDreamnoteCatalogue() {
 const root = document.getElementById("dreamnote-catalogue");
 if (!root) return;

 const tracks = window.DREAMNOTE_TRACKS || [];
 const categories = window.DREAMNOTE_CATEGORIES || [];

 const grid = document.getElementById("dnGrid");
 const searchInput = document.getElementById("dnSearch");
 const categorySelect = document.getElementById("dnCategory");
 const priceSelect = document.getElementById("dnPrice");
 const sortSelect = document.getElementById("dnSort");
 const bottomPagination = document.getElementById("dnPagination");
 let topPagination = document.getElementById("dnPaginationTop");
 const tracksPerPage = 48;
 let currentPage = 1;

 if (!grid || !searchInput || !categorySelect || !priceSelect || !sortSelect || !bottomPagination) return;

 if (!topPagination) {
 topPagination = document.createElement("div");
 topPagination.id = "dnPaginationTop";
 topPagination.className = "dn-pagination dn-pagination-top";
 grid.parentNode.insertBefore(topPagination, grid);
 }

 function cleanText(value) {
 return String(value || "").trim();
 }

 function youtubeThumb(videoId) {
 return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
 }

 function priceMatches(price, band) {
 const numericPrice = Number(price || 0);

 if (band === "all") return true;
 if (band === "under-15") return numericPrice < 15;
 if (band === "15-20") return numericPrice >= 15 && numericPrice <= 20;
 if (band === "over-20") return numericPrice > 20;

 return true;
 }

 function populateCategories() {
 if (categorySelect.dataset.populated === "true") return;

 categories.forEach(category => {
 const option = document.createElement("option");
 option.value = category;
 option.textContent = category;
 categorySelect.appendChild(option);
 });

 categorySelect.dataset.populated = "true";
 }

 function getFilteredTracks() {
 const searchTerm = searchInput.value.toLowerCase().trim();
 const selectedCategory = categorySelect.value;
 const selectedPrice = priceSelect.value;
 const selectedSort = sortSelect.value;

 let filtered = tracks.filter(track => {
 const combinedText = `${track.title} ${track.description} ${track.genre} ${track.instrumentation} ${track.tags}`.toLowerCase();
 const matchesSearch = !searchTerm || combinedText.includes(searchTerm);
 const matchesCategory = selectedCategory === "all" || track.genre === selectedCategory;
 const matchesPrice = priceMatches(track.price, selectedPrice);

 return matchesSearch && matchesCategory && matchesPrice;
 });

 filtered.sort((a, b) => {
 if (selectedSort === "title-asc") return a.title.localeCompare(b.title);
 if (selectedSort === "title-desc") return b.title.localeCompare(a.title);
 if (selectedSort === "price-asc") return Number(a.price || 0) - Number(b.price || 0);
 if (selectedSort === "price-desc") return Number(b.price || 0) - Number(a.price || 0);
 if (selectedSort === "newest") return new Date(b.date) - new Date(a.date);
 return 0;
 });

 return filtered;
 }

 function getThumbMarkup(track) {
 const hasVideo = track.videoId && track.videoId !== "VIDEO_ID_HERE";
 const thumbUrl = hasVideo ? youtubeThumb(track.videoId) : "https://static.wixstatic.com/media/11062b_7f7fca1dd39d4b4eb2f92b7e93d6f940~mv2.jpg";

 return `
 <div class="dn-thumb" role="button" tabindex="0" aria-label="Play preview for ${cleanText(track.title)}">
 <img src="${thumbUrl}" alt="${cleanText(track.title)} preview thumbnail" loading="lazy">
 <div class="dn-thumb-play"><span>▶</span></div>
 </div>
 `;
 }

 function pauseOtherCards(activeCard) {
 grid.querySelectorAll(".dn-card").forEach(card => {
 if (card !== activeCard && card.dataset.loaded === "true") {
 const trackIndex = Number(card.dataset.index);
 const visibleTracks = getFilteredTracks();
 const startIndex = (currentPage - 1) * tracksPerPage;
 const track = visibleTracks[startIndex + trackIndex];
 const mediaSlot = card.querySelector(".dn-media-slot");

 if (track && mediaSlot) {
 mediaSlot.innerHTML = getThumbMarkup(track);
 card.dataset.loaded = "false";
 attachPlayEvents(card, track);
 }
 }
 });
 }

 function loadInlinePlayer(card, track) {
 if (!track.videoId || track.videoId === "VIDEO_ID_HERE") {
 return;
 }

 pauseOtherCards(card);

 const safeVideoId = encodeURIComponent(track.videoId);
 const mediaSlot = card.querySelector(".dn-media-slot");

 mediaSlot.innerHTML = `
 <div class="dn-embed">
 <iframe
 src="https://www.youtube.com/embed/${safeVideoId}?autoplay=1&rel=0"
 title="${cleanText(track.title)} preview"
 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
 referrerpolicy="strict-origin-when-cross-origin"
 allowfullscreen>
 </iframe>
 <p style="position:absolute; left:10px; bottom:8px; margin:0; font-size:11px; background:rgba(0,0,0,0.65); padding:5px 7px; border-radius:8px;">
 <a href="https://www.youtube.com/watch?v=${safeVideoId}" target="_blank" style="color:#fff;">Open preview if blocked</a>
 </p>
 </div>
 `;

 card.dataset.loaded = "true";
 }

 function attachPlayEvents(card, track) {
 const playElements = card.querySelectorAll(".dn-thumb, .dn-button-secondary");

 playElements.forEach(element => {
 element.addEventListener("click", () => loadInlinePlayer(card, track));
 element.addEventListener("keydown", event => {
 if (event.key === "Enter" || event.key === " ") {
 event.preventDefault();
 loadInlinePlayer(card, track);
 }
 });
 });
 }

 function renderPagination(totalPages) {
 const paginationContainers = [topPagination, bottomPagination].filter(Boolean);

 paginationContainers.forEach(container => {
 container.innerHTML = "";
 });

 if (totalPages <= 1) {
 return;
 }

 function goToPage(pageNumber) {
 const requestedPage = Number(pageNumber);

 if (!Number.isInteger(requestedPage) || requestedPage < 1 || requestedPage > totalPages) {
 return;
 }

 currentPage = requestedPage;
 renderTracks();
 grid.scrollIntoView({
 behavior: "smooth",
 block: "start"
 });
 }

 function buildPagination(container, location) {
 const previousButton = document.createElement("button");
 previousButton.type = "button";
 previousButton.className = "dn-page-button";
 previousButton.textContent = "Previous";
 previousButton.disabled = currentPage === 1;
 previousButton.addEventListener("click", () => goToPage(currentPage - 1));

 const pageStatus = document.createElement("label");
 pageStatus.className = "dn-page-status";
 pageStatus.setAttribute("for", `dnPageJump-${location}`);
 pageStatus.textContent = "Page";

 const pageInput = document.createElement("input");
 pageInput.type = "number";
 pageInput.id = `dnPageJump-${location}`;
 pageInput.className = "dn-page-input";
 pageInput.min = "1";
 pageInput.max = String(totalPages);
 pageInput.value = String(currentPage);
 pageInput.inputMode = "numeric";
 pageInput.setAttribute("aria-label", `Enter page number from 1 to ${totalPages}`);

 pageInput.addEventListener("keydown", event => {
 if (event.key === "Enter") {
 event.preventDefault();
 goToPage(pageInput.value);
 }
 });

 pageInput.addEventListener("change", () => goToPage(pageInput.value));

 const pageTotal = document.createElement("span");
 pageTotal.className = "dn-page-status";
 pageTotal.textContent = `of ${totalPages}`;

 const nextButton = document.createElement("button");
 nextButton.type = "button";
 nextButton.className = "dn-page-button";
 nextButton.textContent = "Next";
 nextButton.disabled = currentPage === totalPages;
 nextButton.addEventListener("click", () => goToPage(currentPage + 1));

 container.appendChild(previousButton);
 container.appendChild(pageStatus);
 container.appendChild(pageInput);
 container.appendChild(pageTotal);
 container.appendChild(nextButton);
 }

 buildPagination(topPagination, "top");
 buildPagination(bottomPagination, "bottom");
 }

 function renderTracks() {
 const visibleTracks = getFilteredTracks();
 grid.innerHTML = "";

 const totalPages = Math.max(1, Math.ceil(visibleTracks.length / tracksPerPage));

 if (currentPage > totalPages) {
 currentPage = totalPages;
 }

 if (!visibleTracks.length) {
 grid.innerHTML = `<div class="dn-empty">No tracks match your current search or filters.</div>`;
 if (topPagination) topPagination.innerHTML = "";
 bottomPagination.innerHTML = "";
 return;
 }

 const startIndex = (currentPage - 1) * tracksPerPage;
 const pageTracks = visibleTracks.slice(startIndex, startIndex + tracksPerPage);

 pageTracks.forEach((track, index) => {
 const card = document.createElement("article");
 card.className = "dn-card";
 card.dataset.index = index;
 card.dataset.loaded = "false";

 card.innerHTML = `
 <div class="dn-media-slot">
 ${getThumbMarkup(track)}
 </div>
 <div class="dn-card-body">
 <h3>${cleanText(track.title)}</h3>
 <p>${cleanText(track.description)}</p>
 <div class="dn-tags">
 <span class="dn-tag">${cleanText(track.genre)}</span>
 <span class="dn-tag">$${track.price}</span>
 ${cleanText(track.duration || track.length) ? `<span class="dn-tag dn-tag-duration">${cleanText(track.duration || track.length)}</span>` : ""}
 </div>
 <div class="dn-card-actions">
 <button type="button" class="dn-button-secondary">Play preview</button>
 <a class="dn-button" href="${track.productUrl}" target="_blank" rel="noopener">Buy / License</a>
 </div>
 </div>
 `;

 attachPlayEvents(card, track);
 grid.appendChild(card);
 });

 renderPagination(totalPages);
 }

 [searchInput, categorySelect, priceSelect, sortSelect].forEach(control => {
 control.addEventListener("input", () => {
 currentPage = 1;
 renderTracks();
 });
 control.addEventListener("change", () => {
 currentPage = 1;
 renderTracks();
 });
 });

 populateCategories();
 renderTracks();
 }

 if (document.readyState === "loading") {
 document.addEventListener("DOMContentLoaded", initDreamnoteCatalogue);
 } else {
 initDreamnoteCatalogue();
 }

 document.addEventListener("shopify:section:load", initDreamnoteCatalogue);
})();

